module.exports = __webpack_public_path__ + "img/smart-city.5adcada7.jpg";